import 'store/bolt/pixels.js';
import Store from 'store/store';
import { loadScript } from 'utils/utils';
import { maybeHandle } from 'utils/gdpr/maybeHandle';
import * as categories from 'utils/gdpr/categories';

// Reddit
const fireRedditPageVisit = () => {
	!function(w, d) {
		if (!w.rdt) {
			let p = w.rdt = function() {
				p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
			};
			p.callQueue = [];
			let t = d.createElement('script');
			t.src = 'https://www.redditstatic.com/ads/pixel.js', t.async = !0;
			let s = d.getElementsByTagName('script')[0];
			s.parentNode.insertBefore(t, s);
		}
	}(window, document);
	window.rdt('init', 't2_vaeei22z');
	window.rdt('track', 'PageVisit');
};

Store.on('LANDING', () => {
	maybeHandle('SOCIAL', fireRedditPageVisit, true);
});